import { PopoverOrigin } from '@mui/material'
import customTheme from '.'
import palette from './palette'
import { grey } from '@mui/material/colors'

export const menuPaperStyles = { sx: { minWidth: '200px' } }
export const anchorOrigin: PopoverOrigin = { vertical: 'bottom', horizontal: 'right' }
export const transformOrigin: PopoverOrigin = { vertical: 'top', horizontal: 'right' }
export const displayNone = { sx: { display: 'none' } }
export const caseDetailGrid = {
  paddingInline: '24px',
  paddingBlock: '10px',
  borderBottom: `1px solid ${palette.lightGrayTwo}`
}

export const boxShadowGlobal = {
  boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)'
}

export const taskListStyle = {
  border: `1px solid ${grey[300]}`,
  borderRadius: '4px',
  padding: '10px 16px',
  color: 'gray',
  marginBottom: '13px'
}

export const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export const flexJustifyCenter = {
  display: 'flex',
  justifyContent: 'center'
}

export const flexJustifySpaceBetween = {
  display: 'flex',
  justifyContent: 'space-between'
}

export const flexJustifySpaceBetweenMd = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  justifyContent: { md: 'space-between' }
}

export const flexJustifyEnd = {
  display: 'flex',
  justifyContent: 'flex-end'
}

export const absoluteCenter = {
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

export const drawerImage = {
  maxWidth: '119px',
  width: '100%',
  display: 'block',
  marginTop: '20px',
  marginBottom: '25px'
}

export const autocompletePaperStyles = {
  padding: '10px 20px',
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
  borderTop: `1px solid ${palette.lightGrayTwo}`
}

export const infoText = {
  height: '10px',
  width: '10px',
  borderRadius: '50%',
  marginRight: '5px'
}

export const caseEdit = {
  paddingInline: 0,
  paddingBlock: '16px',
  borderBottom: `1px solid ${palette.lightGrayTwo}`
}

export const menuHeight = {
  style: {
    maxHeight: '190px'
  }
}

export const customPaginationStyles = {
  [customTheme.breakpoints.down('sm')]: {
    justifyContent: 'center'
  }
}
export const eventListingStyle = {
  padding: 0,
  borderRadius: '4px',
  paddingLeft: '4px',
  marginBottom: '8px'
}

export const userTaskListingStyles = {
  fontSize: '8px',
  paddingBlock: 0
}

export const headerListItemsStyle = {
  textTransform: 'uppercase',
  paddingBottom: '16px'
}

export const activeCaseListingStyle = {
  marginTop: '20px',
  maxHeight: '338px',
  overflow: 'auto',
  paddingInline: '5px'
}

export const customPhoneControllerStyle = {
  fontSize: 16,
  borderRadius: '4px',
  padding: '16.5px 14px',
  width: '100%'
}

export const assigneeDropdownStyle = {
  borderRadius: '50%',
  height: '15px',
  width: '15px',
  fontSize: '9px',
  color: 'white',
  marginRight: '5px',
  position: 'absolute',
  right: '-25px',
  top: 0
}

export const ellipsisStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '4',
  WebkitBoxOrient: 'vertical'
}

export const ellipsisTwoLine = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical'
}

export const editExternalUserStyle = {
  marginTop: '10px',
  marginBottom: '20px',
  fontWeight: 'normal'
}

// `top` for an element pinned right under the app bar: the toolbar mixin (56px, 48px landscape, 64px from sm up)
// with every `minHeight` renamed to `top`, so the offset follows the toolbar at each breakpoint.
const minHeightToTop = (styles: object): object =>
  Object.fromEntries(
    Object.entries(styles).map(([key, value]) =>
      key === 'minHeight' ? ['top', value] : [key, typeof value === 'object' ? minHeightToTop(value) : value]
    )
  )
const toolbarOffset = minHeightToTop(customTheme.mixins.toolbar)

// Sticky inside the page content (not fixed to the viewport) so it starts after the sidebar, centres on the
// content, and pushes the page down when a long title wraps. The negative margins cancel <main>'s padding.
export const caseDetailTopBanner = {
  textAlign: 'center',
  py: '8px',
  px: 2,
  mx: -2,
  mt: -2,
  position: 'sticky',
  ...toolbarOffset,
  display: 'flex',
  flexWrap: 'wrap',
  zIndex: 2,
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px'
}

export const ListBoxStyles = {
  background: 'white',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: 1
}

export const TextWrap = {
  display: 'inline-block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}
